
class LegalDoc extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-legal-content]');
    this.nav = this.querySelector('[data-legal-toc]');
    this.list = this.querySelector('[data-legal-toc-list]');
    if (!this.content || !this.nav || !this.list) return;

    const min = Number(this.dataset.minHeadings || 3);
    this.promote();
    const heads = [...this.content.querySelectorAll('h2, h3')]
      .filter((h) => h.textContent.trim());
    if (heads.length < min) return;

    heads.forEach((h, i) => {
      if (!h.id) h.id = this.slug(h.textContent, i);
      const li = document.createElement('li');
      li.className = h.tagName === 'H3' ? 'legal__toc-sub' : '';
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.append(a);
      this.list.append(li);
    });

    this.nav.hidden = false;
    this.spy(heads);
  }

  promote() {
    this.content.querySelectorAll('p').forEach((par) => {

      const text = par.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      const bold = par.querySelector(':scope > b, :scope > strong');
      const boldText = bold ? bold.textContent.replace(/\s+/g, ' ').trim() : '';
      if (bold && text === boldText && text.length <= 120) {
        this.swap(par, /^\d+\.\d/.test(text) ? 'h3' : 'h2', text);
        return;
      }

      if (/^\d+\.\s+\S/.test(text) && text.length <= 100) {
        this.swap(par, 'h2', text);
      }
    });
  }

  swap(par, level, text) {
    const h = document.createElement(level);
    h.className = 'legal__heading';
    h.textContent = text;
    par.replaceWith(h);
  }

  slug(text, i) {
    const base = text.trim().toLowerCase()
      .normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9Ѐ-ӿ]+/g, '-')
      .replace(/^-|-$/g, '');
    return `${base || 'section'}-${i + 1}`;
  }

  spy(heads) {
    if (!('IntersectionObserver' in window)) return;
    const links = new Map([...this.list.querySelectorAll('a')]
      .map((a) => [a.getAttribute('href').slice(1), a]));

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        links.forEach((a) => a.classList.remove('is-current'));
        links.get(e.target.id)?.classList.add('is-current');
      });
    }, { rootMargin: '-10% 0px -80% 0px' });

    heads.forEach((h) => io.observe(h));
  }
}

customElements.define('legal-doc', LegalDoc);
